
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/work/generated/ui/shared/relock-modules-dialog/RelockModulesDialog';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<p>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("modules.relock_modules_dialog")
  },data:data},helper ? helper.call(depth0, "you_have_changed_the_progression_requirements_for__6772bc89", "You have changed the progression requirements for an active course. There may be students who have already progressed to this module and to others that depend on it.", options) : helperMissing.call(depth0, "t", "you_have_changed_the_progression_requirements_for__6772bc89", "You have changed the progression requirements for an active course. There may be students who have already progressed to this module and to others that depend on it.", options)))
    + "</p>\n<p>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("modules.relock_modules_dialog")
  },data:data},helper ? helper.call(depth0, "would_you_like_to_let_students_continue_in_the_cou_a4c36171", "Would you like to let students continue in the course or do you want to re-lock these modules until the new requirements are completed?", options) : helperMissing.call(depth0, "t", "would_you_like_to_let_students_continue_in_the_cou_a4c36171", "Would you like to let students continue in the course or do you want to re-lock these modules until the new requirements are completed?", options)))
    + "</p>";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  